import { render, staticRenderFns } from "./add-new-broker.vue?vue&type=template&id=dd85ffaa"
import script from "./add-new-broker.vue?vue&type=script&lang=js"
export * from "./add-new-broker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports